import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useDrHistoryRange } from './queries/drHistoryQueries';
import { drSettlementQueryKeys } from './queries/drSettlementQueries';
import { api } from '../utils/api';

export const useDRHistorySimple = (params = {}) => {
  const { data: drHistoryRangeData, isLoading, error } = useDrHistoryRange(params);
  const responseList = drHistoryRangeData?.responseList || [];

  // responseList의 각 항목에 대해 Settlement 쿼리 생성
  const settlementQueries = useMemo(() => {
    if (responseList.length === 0) return [];
    return responseList.map((item) => {
      const targetDate = dayjs(item.date).format('YYYY-MM-DD');
      const startEndTime = `${item.startTime.replace(':', '')}-${item.endTime.replace(':', '')}`;
      
      return {
        queryKey: drSettlementQueryKeys.drHistory({
          TargetDate: targetDate,
          StartEndTime: startEndTime,
        }),
        queryFn: async () => {
          const response = await api.get(`/drivecore/stm/api/PowerContractNumberSettlement/DrSettlement`, {
            params: {
              TargetDate: targetDate,
              StartEndTime: startEndTime,
            }
          });
          return response;
        },
        enabled: !!targetDate && !!startEndTime,
      };
    });
  }, [responseList]);

  // useQueries를 사용하여 모든 Settlement 쿼리 병렬 실행
  const settlementQueryResults = useQueries({
    queries: settlementQueries,
  }) || [];

  // Settlement 데이터를 responseList와 매핑
  const drSettlementList = useMemo(() => {
    if (!settlementQueryResults || settlementQueryResults.length === 0) return [];
    return settlementQueryResults.map((queryResult, index) => {
      const item = responseList[index];
      if (!item || !queryResult.data) return null;
      
      const targetDate = dayjs(item.date).format('YYYY-MM-DD');
      const startEndTime = `${item.startTime.replace(':', '')}-${item.endTime.replace(':', '')}`;
      
      return queryResult.data?.Items || [];
    });
  }, [settlementQueryResults, responseList]);

  // 전체 로딩 상태 (drHistoryRange 로딩 또는 Settlement 쿼리 중 하나라도 로딩 중이면 true)
  const isLoadingSettlements = settlementQueryResults && settlementQueryResults.length > 0 
    ? settlementQueryResults.some((query) => query.isLoading)
    : false;
  const isTotalLoading = isLoading || isLoadingSettlements;

  // 에러 상태
  const settlementError = settlementQueryResults && settlementQueryResults.length > 0
    ? settlementQueryResults.find((query) => query.error)?.error
    : null;
  const hasError = error || settlementError;
  return {
    drHistoryRangeData: {
      ...drHistoryRangeData,
      responseList: responseList.map((item, index) => ({
        ...item,
        settlement: drSettlementList[index] || null,
      })),
    },
    drSettlementList,
    isLoading: isTotalLoading,
    drHistoryRangeLoading: isLoading,
    error: hasError,
    drHistoryRangeError: error,
  };
};